import advanceReportingConstants from "@/constants/advanceReportingConstants"
import moment from "moment-timezone"

export const getMinDate = (schoolYear, activeSchoolTimeZone) => {
  if (schoolYear?.value) {
    return moment(`${schoolYear?.value?.[0]}-07-01`).tz(activeSchoolTimeZone)
  }
  return moment().tz(activeSchoolTimeZone)
}

export const getMaxDate = (schoolYear, activeSchoolTimeZone) => {
  if (schoolYear?.value) {
    return moment(`${schoolYear?.value?.[1]}-06-30`).tz(activeSchoolTimeZone)
  }
  return moment().tz(activeSchoolTimeZone)
}

export const getThisMonthRange = (minDate) => {
  const monthStart = moment().startOf("month")
  const monthEnd = moment().endOf("month")
  const adjustedStart = monthStart.isBefore(minDate) ? minDate : monthStart

  return {
    startDate: adjustedStart.format("MM/DD/YYYY"),
    endDate: monthEnd.format("MM/DD/YYYY")
  }
}

export const calculatePreviousDatesForMonth = (startDate) => {
  if (!startDate) {
    return { previousStartDate: null, previousEndDate: null }
  }

  const currentStart = moment(startDate, "YYYY-MM-DD")
  const currentMonthStart = currentStart.clone().startOf("month")
  const currentMonthEnd = currentStart.clone().endOf("month")
  const previousMonthStart = currentMonthStart
    .clone()
    .subtract(1, "month")
    .startOf("month")
  const previousMonthEnd = currentMonthEnd
    .clone()
    .subtract(1, "month")
    .endOf("month")

  return {
    previousStartDate: previousMonthStart.format("YYYY-MM-DD"),
    previousEndDate: previousMonthEnd.format("YYYY-MM-DD")
  }
}

export const getThisMonthDateRangeForStore = (
  schoolYear,
  activeSchoolTimeZone
) => {
  const minDate = getMinDate(schoolYear, activeSchoolTimeZone)
  const thisMonthRange = getThisMonthRange(minDate)

  const startDate = moment(thisMonthRange.startDate, "MM/DD/YYYY").format(
    "YYYY-MM-DD"
  )
  const endDate = moment(thisMonthRange.endDate, "MM/DD/YYYY").format(
    "YYYY-MM-DD"
  )

  const { previousStartDate, previousEndDate } =
    calculatePreviousDatesForMonth(startDate)

  return {
    type: advanceReportingConstants.DATE_RANGE_TYPES.THIS_MONTH,
    startDate,
    endDate,
    previousStartDate,
    previousEndDate
  }
}
